module.exports = __webpack_public_path__ + "04_veryshort_gray.c34686d3.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/dad/layer5/04_veryshort_gray.png
// module id = c1f1
// module chunks = 0